<div fxLayout="column">
  <!-- IE requires all fxLayout="column" elements to have the child contents wrapped in a plain div tag -->
  <div *ngIf="isBrowserIE; else forgotPasswordFlexColumnTemplate" [ngClass]="{ 'ie-display': isBrowserIE }">
    <ng-container *ngTemplateOutlet="forgotPasswordFlexColumnTemplate"></ng-container>
  </div>
</div>

<ng-template #forgotPasswordFlexColumnTemplate>
  <div fxFlex.lt-md="10px" fxFlex.gt-sm="25px">&nbsp;</div>
  <div fxFlex="100%" fxLayout="column" fxLayoutGap.lt-md="10px" class="large-paragraph-spacing">
    <div
      *ngIf="isBrowserIE && media.isActive('lt-md'); else forgotPasswordMessagesFlexColumnTemplate"
      [ngClass]="{ 'ie-display': isBrowserIE }"
    >
      <ng-container *ngTemplateOutlet="forgotPasswordMessagesFlexColumnTemplate"></ng-container>
    </div>
  </div>
  <div fxFlex="100%" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap.lt-md="10px">
    <div *ngIf="isBrowserIE && media.isActive('lt-md'); else forgotPasswordMainFlexColumnTemplate">
      <ng-container *ngTemplateOutlet="forgotPasswordMainFlexColumnTemplate"></ng-container>
    </div>
  </div>
  <div fxFlex.lt-md="10px" fxFlex.gt-sm="25px">&nbsp;</div>
</ng-template>

<ng-template #forgotPasswordMessagesFlexColumnTemplate>
  <div fxFlex="5%" fxHide.lt-md></div>
  <!-- Instruction Messages -->
  <div
    fxFlex="90%"
    fxLayoutAlign="center center"
    ngStyle.lt-md="padding-left: 8px; padding-right: 8px"
    class="large-paragraph-pre-spacing"
    *ngIf="showInstructionMessagesSpinner"
  >
    <mat-spinner color="accent" diameter="32"></mat-spinner>
  </div>
  <div
    fxFlex="90%"
    ngStyle.lt-md="padding-left: 8px; padding-right: 8px"
    class="large-paragraph-pre-spacing"
    *ngIf="!showInstructionMessagesSpinner && this.instructionMessageList.length > 0"
  >
    <div
      ngStyle.gt-sm="padding-left: 24px; padding-right: 24px"
      ngStyle.lt-md="padding-left: 8px; padding-right: 8px"
      class="extra-large-display-text normal-paragraph-spacing center-text"
      [ngClass]="getMessageCssClass(item)"
      *ngFor="let item of this.instructionMessageList"
    >
      {{ item.messageText }}
    </div>
  </div>
  <div fxFlex="5%" fxHide.lt-md></div>
</ng-template>

<ng-template #forgotPasswordMainFlexColumnTemplate>
  <div fxFlex="50%" fxHide.lt-md></div>
  <div fxFlex="500px" fxFlex.lt-md="100%" ngStyle.lt-md="padding-left: 8px; padding-right: 8px;">
    <div class="display-text normal-paragraph-spacing">
      <mat-card>
        <mat-card-content>
          <div fxLayout="column">
            <div *ngIf="isBrowserIE; else forgotPasswordFormFlexColumnTemplate">
              <ng-container *ngTemplateOutlet="forgotPasswordFormFlexColumnTemplate"></ng-container>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
  <div fxFlex="50%" fxHide.lt-md></div>
</ng-template>

<ng-template #forgotPasswordFormFlexColumnTemplate>
  <div fxLayout="column">
    <div class="display-text primary-dark-color-important">
      <b><span i18n="@@forgot-password.form.title">forgot-password.form.title</span></b>
    </div>
    <div class="border-bottom-blue" style="margin-top: 16px; margin-bottom: 16px;"></div>
    <div class="display-text">
      <ng-container *ngTemplateOutlet="forgotPasswordFormPart1FlexColumnTemplate"></ng-container>
      <ng-container *ngTemplateOutlet="forgotPasswordFormPart2FlexColumnTemplate"></ng-container>
      <ng-container *ngTemplateOutlet="forgotPasswordFormPart3FlexColumnTemplate"></ng-container>
    </div>
  </div>
</ng-template>

<ng-template #forgotPasswordFormPart1FlexColumnTemplate>
  <form [formGroup]="forgotPasswordFormPart1">
    <div fxLayout="column">
      <div fxLayout="row" fxLayoutAlign="center center" class="display-text">
        <mat-form-field ngStyle.gt-sm="width: 80%" fxFlex.lt-md="90%" *ngIf="!userVerified">
          <input
            matInput
            i18n-placeholder="@@forgot-password.form.user-name.placeholder"
            placeholder="forgot-password.form.user-name.placeholder"
            type="text"
            [formControl]="userNameFormControl"
            autocomplete="off"
            [maxlength]="fieldValidations.userRegistration.userNameMaxLength"
            required
          />
          <mat-error *ngIf="userNameFormControl.hasError('required')" i18n="@@forgot-password.form.error.required"
            >forgot-password.form.error.required</mat-error
          >
        </mat-form-field>
        <mat-form-field ngStyle.gt-sm="width: 80%" fxFlex.lt-md="90%" *ngIf="userVerified">
          <input
            matInput
            i18n-placeholder="@@forgot-password.form.user-name.placeholder"
            placeholder="forgot-password.form.user-name.placeholder"
            type="text"
            [value]="forgotPasswordInfo.userName"
            autocomplete="off"
            readonly
            disabled
          />
          <mat-icon matSuffix>done</mat-icon>
        </mat-form-field>
      </div>
      <div fxLayout="row" fxLayoutAlign="center center" class="normal-paragraph-spacing" *ngIf="!userVerified">
        <a (click)="forgotUserName()" class="anchor-link accent-color-important" i18n="@@forgot-password.form.forgot-username-link.label"
          >forgot-password.form.forgot-username-link.label</a
        >
      </div>
      <div fxLayout="row" fxLayoutAlign="center center" class="display-text">
        <mat-form-field ngStyle.gt-sm="width: 80%" fxFlex.lt-md="90%" *ngIf="!userVerified">
          <input
            matInput
            i18n-placeholder="@@forgot-password.form.social-security-number.placeholder"
            placeholder="forgot-password.form.social-security-number.placeholder"
            type="text"
            [formControl]="socialSecurityNumberFormControl"
            autocomplete="off"
            [maxlength]="fieldValidations.userRegistration.socialSecurityLastFourNumberMaxLength"
            required
            onkeypress="return isNumberKey(this, event, 0)"
          />
          <mat-hint align="end" i18n="@@forgot-password.form.hint.social-security-number"
            >forgot-password.form.hint.social-security-number</mat-hint
          >
          <mat-error *ngIf="socialSecurityNumberFormControl.hasError('required')" i18n="@@forgot-password.form.error.required"
            >forgot-password.form.error.required</mat-error
          >
          <mat-error
            *ngIf="
              (socialSecurityNumberFormControl.hasError('minlength') || socialSecurityNumberFormControl.hasError('maxlength')) &&
              !socialSecurityNumberFormControl.hasError('required')
            "
            i18n="@@forgot-password.form.error.social-security-number"
            >forgot-password.form.error.social-security-number</mat-error
          >
        </mat-form-field>
        <mat-form-field ngStyle.gt-sm="width: 80%" fxFlex.lt-md="90%" *ngIf="userVerified">
          <input
            matInput
            i18n-placeholder="@@forgot-password.form.social-security-number.placeholder"
            placeholder="forgot-password.form.social-security-number.placeholder"
            type="text"
            [value]="forgotPasswordInfo.ssnLastFour"
            autocomplete="off"
            readonly
            disabled
          />
          <mat-icon matSuffix>done</mat-icon>
        </mat-form-field>
      </div>
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        class="display-text normal-paragraph-spacing normal-paragraph-pre-spacing"
        *ngIf="!userVerified"
      >
        <re-captcha formControlName="recaptchaFormControl" siteKey="{{ recaptchaSiteKey }}" required></re-captcha>
      </div>
      <div fxLayout="row" fxLayoutAlign="center center" class="display-text normal-paragraph-spacing" *ngIf="!userVerified">
        <button
          mat-flat-button
          color="primary"
          (click)="verifyUser()"
          [disabled]="!verifyEnabled()"
          i18n="@@forgot-password.form.verify-button.label"
        >
          forgot-password.form.verify-button.label
        </button>
      </div>
      <div fxLayout="row" fxLayoutAlign="center center" class="display-text" *ngIf="showVerifyUserSpinner">
        <mat-spinner color="accent" diameter="32"></mat-spinner>
      </div>
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        style="text-align: center;"
        class="display-text warning-color normal-paragraph-spacing"
        *ngIf="showVerifyError"
      >
        <b><span i18n="@@forgot-password.verify-message.error.1">forgot-password.verify-message.error.1</span></b>
      </div>
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        style="text-align: center;"
        class="display-text warning-color normal-paragraph-spacing"
        *ngIf="showVerifyError"
      >
        <b><span i18n="@@forgot-password.verify-message.error.2">forgot-password.verify-message.error.2</span></b>
      </div>
    </div>
  </form>
</ng-template>

<ng-template #forgotPasswordFormPart2FlexColumnTemplate>
  <form [formGroup]="forgotPasswordFormPart2">
    <div fxLayout="column">
      <div fxLayout="row" fxLayoutAlign="center center" class="display-text normal-paragraph-pre-spacing" *ngIf="userVerified">
        <mat-form-field ngStyle.gt-sm="width: 80%" fxFlex.lt-md="90%">
          <input
            matInput
            i18n-placeholder="@@forgot-password.form.security-question-text.placeholder"
            placeholder="forgot-password.form.security-question-text.placeholder"
            type="text"
            autocomplete="off"
            [value]="forgotPasswordInfo.securityQuestionText"
            readonly
            disabled
          />
        </mat-form-field>
      </div>
      <div fxLayout="row" fxLayoutAlign="center center" class="display-text" *ngIf="userVerified">
        <mat-form-field ngStyle.gt-sm="width: 80%" fxFlex.lt-md="90%">
          <input
            #securityQuestionAnswerRef
            matInput
            i18n-placeholder="@@forgot-password.form.security-question-answer.placeholder"
            placeholder="forgot-password.form.security-question-answer.placeholder"
            type="text"
            [formControl]="securityQuestionAnswerFormControl"
            autocomplete="off"
            [maxlength]="fieldValidations.userRegistration.securityQuestionAnswerMaxLength"
            required />
          <!--<mat-hint align="end" i18n="@@forgot-password.form.hint.security-question-answer"
            >forgot-password.form.hint.security-question-answer</mat-hint> -->
          <mat-error *ngIf="securityQuestionAnswerFormControl.hasError('required')"
               i18n="@@forgot-password.form.error.required">forgot-password.form.error.required</mat-error>
          <!--  <mat-error
               *ngIf="securityQuestionAnswerFormControl.hasError('pattern') && !securityQuestionAnswerFormControl.hasError('required')"
               i18n="@@forgot-password.form.error.confirm-securityanswer">forgot-password.form.error.confirm-securityanswer</mat-error> -->
        </mat-form-field>
      </div>
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        style="text-align: center;"
        class="display-text warning-color normal-paragraph-spacing"
        *ngIf="showQuestionError"
      >
        <b><span i18n="@@forgot-password.question-message.error.1">forgot-password.question-message.error.1</span></b>
      </div>
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        style="text-align: center;"
        class="display-text warning-color normal-paragraph-spacing"
        *ngIf="showQuestionError"
      >
        <b><span i18n="@@forgot-password.question-message.error.2">forgot-password.question-message.error.2</span></b>
      </div>
    </div>
  </form>
</ng-template>

<ng-template #forgotPasswordFormPart3FlexColumnTemplate>
  <form [formGroup]="forgotPasswordFormPart3">
    <div fxLayout="column">
      <div fxLayout="row" fxLayoutAlign="center center" class="display-text normal-paragraph-pre-spacing" *ngIf="userVerified">
        <mat-form-field ngStyle.gt-sm="width: 80%" fxFlex.lt-md="90%">
          <input
            matInput
            i18n-placeholder="@@forgot-password.form.email-address.placeholder"
            placeholder="forgot-password.form.email-address.placeholder"
            type="email"
            autocomplete="off"
            [value]="forgotPasswordInfo.homeEmail"
            readonly
            disabled
          />
        </mat-form-field>
      </div>
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        class="display-text normal-paragraph-spacing"
        *ngIf="userVerified && !showSubmitSpinner"
      >
        <button
          mat-flat-button
          color="primary"
          (click)="submitUser()"
          i18n="@@forgot-password.form.submit-button.label"
          [disabled]="!submitEnabled()"
        >
          forgot-password.form.submit-button.label
        </button>
        &nbsp;&nbsp;
        <button mat-stroked-button color="primary" (click)="resetForm()" i18n="@@forgot-password.form.reset-button.label">
          forgot-password.form.reset-button.label
        </button>
      </div>
      <div fxLayout="row" fxLayoutAlign="center center" class="display-text" *ngIf="showSubmitSpinner">
        <mat-spinner color="accent" diameter="32"></mat-spinner>
      </div>
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        style="text-align: center;"
        class="display-text warning-color normal-paragraph-spacing"
        *ngIf="showSubmitError"
      >
        <b><span i18n="@@forgot-password.submit-message.error.2">forgot-password.submit-message.error.2</span></b>
      </div>
    </div>
  </form>
</ng-template>
